<template>
  <div class="record" ref="record">
    <div class="DIY_21_Bg" @click="popupVideoWin">
      <div class="video" ref="video">
        <!-- <span class="video_desc">{{desc}}</span> -->
        <!-- 新天钢（23）默认视频 -->
        <video
          v-if="customerId === 23"
          src="http://localhost:4050/himg/2HLP-10-220409-171955.mp4"
          width="800"
          height
          autoplay="autoplay"
          loop
          muted
          controls
          id="myvideo2"
        ></video>
        <video
          v-else-if="imgUrl && imgUrl.toLowerCase().indexOf('mp4') != -1"
          :src="imgUrl"
          width="800"
          height
          autoplay="autoplay"
          loop
          muted
          controls
          id="myvideo"
        ></video>
        <img v-else :src="imgUrl" style="width: 800px" />
        <div class="videoBg"></div>
      </div>
      <div ref="news" class="news">
        <div ref="list" class="list">
          <dl>
            <dd class="addres" :style="{'font-size': customerId == 42 ? '22px' : '18px'}">{{ customerId === 23 ? "2号原料场" : address }}</dd>
          </dl>
          <dl>
            <dd :style="{'font-size': customerId == 42 ? '19px' : '18px'}" v-if="customerId !== 23">{{ DTime }}</dd>
            <dd :style="{'font-size': customerId == 42 ? '19px' : '18px'}">{{ customerId === 23 ? "ME2147雾炮" : deviceName }}</dd>
          </dl>
        </div>
        <div ref="scrollDiv" class="scrollDiv" id="s3">
          <marquee width="100%" height="95px" direction="up" scrollamount="2">
            <ul>
              <li v-bind:key="index" v-for="(item, index) in describeList">
                <a>
                  <span>●</span>
                  <span :style="{ 'font-size': customerId == 42 ? '20px' : '16px' }">
                    {{
                    item
                    }}
                  </span>
                </a>
              </li>
            </ul>
          </marquee>
        </div>
        <div class="status" :style="{ color: statusImg }">{{ Result }}</div>
        <div class="slider-block" style="display: none">
          <el-slider @input="sliderChange" v-model="sliderValue" :show-tooltip="false" vertical height="85px"></el-slider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import videoPopup from './components/videoPopup.vue'
export default {
  title: '无组织控制记录',
  props: ['matrix', 'x', 'y'],
  data() {
    return {
      pageInfo: 'record_new.vue',
      computedName: '无组织控制记录组件',
      customerId: this.$store.state.customerId,
      SETINTER: null,
      SETINTER2: null,
      imgUrl: '',
      address: '',
      DTime: '',
      describe: '',
      endTimeDescribe: '',
      describeList: [],
      deviceName: '',
      Result: '',
      statusImg: '',
      //道路清洁
      dayWashCarCount: 0,
      allWashCar: 0,
      allWashCarCount: 0,
      //洗车台
      dayCount: 0,
      allCar: 0,
      allCount: 0,
      marquee: null,
      sliderValue: 100,
      scrollTimer: null,
      desc: '',
      selectRow: {}
    }
  },
  computed: {
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent'
    })
  },
  // watch: {
  //   imgUrl(newval) {
  //     if (newval.toLowerCase().indexOf('mp4') != -1) {
  //       this.$nextTick(() => {
  //         this.initVideoDesc();
  //       });
  //     }
  //   },
  // },
  mounted() {
    let that = this
    let w = $(that.$refs.record).outerWidth()
    let h = $(that.$refs.record).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })

    this.getData()

    //滚动
    if (this.marquee) {
      clearInterval(this.marquee)
    }

    let this_ = this
    $(this.$refs.scrollDiv).unbind('scroll')
    $(this.$refs.scrollDiv).bind('scroll', function () {
      if (this_.scrollTimer) {
        clearTimeout(this_.scrollTimer)
      }
      this_.scrollTimer = setTimeout(function () {
        this_.scrollCB()
      }, 15)
    })
  },
  unmounted() {
    if (this.SETINTER) {
      clearTimeout(this.SETINTER)
      this.SETINTER = null
    }
  },
  methods: {
    async getData() {
      if (this.SETINTER) {
        clearTimeout(this.SETINTER)
      }
      let findClosedLoop = CONFIG.requestName + this.$apiOpt.findClosedLoop
      let data = await this.$apiUtils.get(findClosedLoop, {
        customerId: this.customerId
      })
      if (data != null && data != undefined) {
        this.describeList = []
        // this.imgUrl = data.fileName;
        // this.imgUrl="./img/IMG_3588.mp4";
        if (this.customerId == 23) {
          this.imgUrl = 'http://localhost:4050/himg/2HLP-10-220409-171955.mp4'
        } else {
          this.imgUrl = data.fileName
        }
        this.address = data.position
        this.DTime = data.createTime
        this.deviceName = data.deviceName
        this.describe = data.describe + data.describe1
        this.endTimeDescribe = data.describe2
        this.selectRow = data
        if (data.describe) {
          data.describe.split('；').forEach(item => {
            this.describeList.push(item)
          })
        }
        if (data.describe1) {
          data.describe1.split('；').forEach(item => {
            this.describeList.push(item)
          })
        }
        if (data.describe2) {
          data.describe2.split('；').forEach(item => {
            this.describeList.push(item)
          })
        }
        this.Result = data.result
        if (data.result == '已处理') {
          this.statusImg = 'rgba(0, 255, 208, 1)'
        } else if (data.result == '处理中') {
          this.statusImg = 'rgba(245, 166, 35, 1)'
        } else if (data.result == '未处理') {
          this.statusImg = 'rgba(186, 199, 231, 1)'
        }
      }
      this.SETINTER = setTimeout(() => {
        this.getData()
      }, 10 * 60 * 1000)
    },
    sliderChange() {
      let delta = 100 - this.sliderValue
      this.$refs.scrollDiv.scrollTop =
        (delta / 100) * ($(this.$refs.scrollDiv).find('ul').outerHeight() - $(this.$refs.scrollDiv).outerHeight())
    },
    scrollCB() {
      this.sliderValue =
        100 -
        (this.$refs.scrollDiv.scrollTop / ($(this.$refs.scrollDiv).find('ul').outerHeight() - $(this.$refs.scrollDiv).outerHeight())) * 100
    },
    AutoScroll(obj) {
      $(obj)
        .find('ul:first')
        .animate(
          {
            marginTop: '-25px'
          },
          500,
          function () {
            $(this)
              .css({
                marginTop: '0px'
              })
              .find('li:first')
              .appendTo(this)
          }
        )
    },
    popupVideoWin() {
      if (!this.imgUrl) return
      this.$store.commit('dialogStatus', true)
      this.$popup.open(
        videoPopup,
        this.dialogCompontent,
        {},
        {
          videoUrl: this.imgUrl
          // videoUrl:'https://vod.pipi.cn/fec9203cvodtransbj1251246104/ccff07ce5285890807898977876/v.f42906.mp4'
        }
      )
    },
    initVideoDesc() {
      if (this.customerId != 23) {
        let that = this
        const video = document.getElementById('myvideo')
        video.ontimeupdate = function (e) {
          const time = video.currentTime
          let duration = Math.floor(video.duration / 3)
          if (time < duration * 1) {
            that.desc = that.selectRow.describe
          } else if (duration * 1.5 < time && time < duration * 2.2) {
            that.desc = that.selectRow.describe1
          } else if (time > duration * 2.3) {
            that.desc = that.selectRow.describe2
          } else {
            that.desc = ''
          }
        }
      } else {
        let that = this
        const video = document.getElementById('myvideo2')
        video.ontimeupdate = function (e) {
          const time = video.currentTime
          let duration = Math.floor(video.duration / 3)
          if (time < duration * 1) {
            that.desc = that.describeList[0]
          } else if (duration * 1.2 < time && time < duration * 2) {
            that.desc = that.describeList[1]
          } else if (duration * 2.3 < time && time < duration * 2.8) {
            that.desc = that.describeList[2]
          } else if (time > duration * 3.3) {
            that.desc = that.describeList[3]
          } else {
            that.desc = ''
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.record {
  width: 600px;
  height: 250px;
  .DIY_21_Bg {
    display: flex;
    .video {
      width: 50%;
      padding: 5px;
      overflow: hidden;
      border-radius: 2px;
      position: relative;
      .video_desc {
        position: absolute;
        font-size: 14px;
        color: hotpink;
        top: 4%;
        left: 4%;
        font-weight: bold;
      }
      video {
        width: 100%;
        object-fit: fill;
      }
      .videoBg {
        position: absolute;
        @include bg-box(270px, 160px, 'noVideo1.png');
        top: 0;
        z-index: -1;
        // display:none;
        margin-top: 5px;
      }
    }
    .news {
      width: 50%;
      padding: 5px;
      font-size: 19px;
      position: relative;
      .list {
        overflow: auto;
        dl {
          margin-bottom: 5px;
          position: relative;
          &:nth-of-type(1) {
            dd {
              height: 18px;
              font-size: 18px;
              font-weight: 500;
              color: #6491ff;
              line-height: 18px;
            }
          }
          &:nth-of-type(2) {
            dd {
              font-size: 14px;
              font-weight: 300;
              color: #bac7e7;
              line-height: 1.5;
            }
          }
          &:nth-of-type(4) {
            dd {
              color: #00fcff;
            }
          }
          dd {
            position: relative;
            font-size: 14px;
            min-height: initial;
            line-height: 22px;
          }
        }
      }
      .scrollDiv {
        overflow: auto;
        height: 95px;
        &::-webkit-scrollbar {
          display: none;
        }
        ul {
          li {
            a {
              span {
                font-size: 16px;
                font-weight: 400;
                color: #f4c48f;
                line-height: 22px;
              }
            }
          }
        }
      }
      .status {
        position: absolute;
        top: 12px;
        right: 12px;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
      }
    }
  }
}

.slider-block {
  position: absolute;
  right: -30px;
  height: 85px;
  bottom: 5px;
  z-index: 999;
}
</style>
<style type="text/css">
.vjs-loading-spinner {
  display: none;
}
.video-player {
  width: 100%;
  height: 100%;
}
.vjs-control-bar,
.vjs-error-display,
.vjs-modal-dialog,
.video-js.vjs-paused .vjs-big-play-button {
  display: none !important;
}
.vjs-big-play-button {
  display: none;
}
video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
</style>
